import * as React from "react";
const SvgFiRrSprinkler = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sprinkler_svg__a)">
      <path
        fill="#062147"
        d="M20 7.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 20 7.5M22.5 6a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 22.5 6m0 3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 9m-17-3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 6m-4-3a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 1.5 3m0 6a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 1.5 9M17 13v10a1 1 0 1 1-2 0V13c0-.552-.449-1-1-1h-4c-.551 0-1 .448-1 1v10a1 1 0 1 1-2 0V13c0-1.654 1.346-3 3-3h1V5.91c-1.732-.317-3.184-1.447-3.843-3.056A2.07 2.07 0 0 1 7.352.909 2.05 2.05 0 0 1 9.055.001h5.89c.685 0 1.322.34 1.703.908.386.574.459 1.302.195 1.945C16.184 4.463 14.731 5.593 13 5.91V10h1c1.654 0 3 1.346 3 3m-5-9c1.344 0 2.519-.747 2.993-1.904L14.945 2h-5.89c-.014 0-.027 0-.042.022C9.482 3.252 10.656 4 12 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sprinkler_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSprinkler;
